import styled from 'styled-components';

const MainLayoutContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.colors.primary};
  padding: 25px;
`;

const MainLayoutCard = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  position: relative;
  overflow: auto;
  position: relative;
`;

const MainLayoutHeader = styled.div`
  position: fixed;
  left: 25px;
  right: 25px;
  display: flex;
  height: 120px;
  z-index: 1000;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border: 0.5px solid ${props => props.theme.colors.grey};
  background: #fff;
  border-radius: 8px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;

  ${props => props.theme.media.phone`
    justify-content: center;
  `}
`;

const MainLayoutContent = styled.div`
  padding: 20px;
  padding-top: 150px;

  ${props =>
    props.flexColumn &&
    `
    display: flex;
    flex-direction: column;
  `}
`;

const LogoContainer = styled.div`
  width: 200px;
  height: auto;

  ${props => props.theme.media.phone`
    display: none;
  `}
`;

const LogoImage = styled.img`
  width: 100%;
  height: auto;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const Row = styled.div`
  display: flex;
  margin-top: 5px;
  width: 100%;
  justify-content: space-between;
`;

export {
  MainLayoutContainer,
  MainLayoutCard,
  MainLayoutHeader,
  MainLayoutContent,
  LogoContainer,
  LogoImage,
  TextContainer,
  Row,
};
